import type { NetworkId } from '@onyx/shared';

/** Token standards users recognise; L2 short names would only repeat the network's own name. */
const TOKEN_STANDARDS = new Set(['TRC-20', 'ERC-20', 'BEP-20', 'SPL', 'Jetton']);
export const standardTag = (standard: string): string | null => (TOKEN_STANDARDS.has(standard) ? standard : null);

/** Network discs wear the chain's recognisable colour. */
export const NETWORK_COLOR: Record<NetworkId, string> = {
  tron: '#ef0027',
  ton: '#0098ea',
  ethereum: '#627eea',
  arbitrum: '#28a0f0',
  optimism: '#ff0420',
  base: '#0052ff',
  polygon: '#8247e5',
  bsc: '#f0b90b',
  solana: '#9945ff',
  avalanche: '#e84142',
  bitcoin: '#f7931a',
  litecoin: '#345d9d',
  dogecoin: '#c2a633',
};
